import { withFilterErrorBoundary } from './FilterErrorBoundary';
import { SearchStringFilter } from './SearchStringFilter';
/**
 * This is a generic multiselect filter that can be used to filter on any metadata property that has allowed values.
 */
export const CustomMetadataAllowedValuesFilter = withFilterErrorBoundary((props) => {
    const { field, label, allowedValues } = props;
    const items = allowedValues.reduce((acc, current) => {
        const { text, value, groupValues } = current;
        const newValues = [];
        if (value && value.length) {
            newValues.push({ title: text, id: value });
        }
        groupValues === null || groupValues === void 0 ? void 0 : groupValues.forEach((groupValue) => {
            newValues.push({ title: groupValue.text, id: groupValue.value });
        });
        return [...acc, ...newValues];
    }, []);
    return <SearchStringFilter name={field} items={items} label={label}/>;
});
